function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.3512 3.2976L7.1752 3.7734C6.0266 6.8772 3.5796 9.3242 0.476 10.4726L0 10.6488L0.476 10.8248C3.5796 11.9734 6.0266 14.4204 7.1752 17.524L7.3512 18L7.5274 17.524C8.6758 14.4204 11.1228 11.9734 14.2266 10.8248L14.7024 10.6488L14.2266 10.4726C11.1228 9.3242 8.6758 6.8772 7.5274 3.7734L7.3512 3.2976ZM14.7024 0L14.6234 0.2134C14.1082 1.6058 13.0106 2.7034 11.6184 3.2186L11.405 3.2976L11.6184 3.3766C13.0106 3.8918 14.1082 4.9894 14.6234 6.3816L14.7024 6.595L14.7814 6.3816C15.2966 4.9894 16.3942 3.8918 17.7866 3.3766L18 3.2976L17.7866 3.2186C16.3942 2.7034 15.2966 1.6058 14.7814 0.2134L14.7024 0Z",
  fill: "#317AD0"
});
function SvgIconAiIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiIndicator);
export default __webpack_public_path__ + "static/media/icon-ai-indicator.10b9000a.svg";
export { ForwardRef as ReactComponent };